module.exports = __webpack_public_path__ + "assets/img/m1.2d49505a.png";